<div class="modal active">
    <div class="modal__container">
        <div class="fields">
            <h2>Frequency Corrections Found</h2>
            <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
              <div class="fields__container" style="flex-direction: column;justify-content: flex-start;">
                <div class="fields__block">
                  <div class="fields__block__section">
                    <div class="table-fields">
                      <h4> The following {{duplicates.length}} facilities were imported as DME(ILS) because the operating channel is associated with an ILS frequency, 
                        although the collocated ILS record was not found in the snapshot </h4>
                        <!-- <div class="filter">
                          <a (click)="selectAll()" style="cursor: pointer">Select All</a>
                          <a (click)="deselectAll()" style="cursor: pointer">Deselect All</a>
                        </div> -->
                      <div style="height: 240px; overflow-y:auto;">
                          <table>
                              <thead>
                                <tr>
                                  <th>ID</th>
                                  <th>Name</th>
                                  <th>Type</th>
                                  <th>Icao CC</th>
                                  <th>Published</th>
                                  <th>Latitude</th>
                                  <th>Longitude</th>
                                  <th>VHF Frequency</th>
                                  <th>Channel</th>
                                </tr>
                              </thead>
                                <tbody>
                                  <tr *ngFor="let navaid of duplicates; let i = index">
                                    <td>{{navaid.navaidid}}</td>
                                    <td>{{navaid.name}}</td>
                                    <td>{{navaid.navaidtype}}</td>
                                    <td>{{navaid.icaocc}}</td>
                                    <td>{{navaid.Published}}</td>
                                    <td>{{navaid.latitude}}</td>
                                    <td>{{navaid.longitude}}</td>
                                    <td>{{navaid.vhfTunFreqInput}}</td>
                                    <td>{{navaid.channel}}</td>
                                  </tr>
                              </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="fields__btn">
                    <button (click)="proceedWithImport()" class="blue">Ok</button>
  
                    <button (click)="exportNavaidsToCsv();" class="blue" >Export</button>
                </div>
            </div>
        </div>
    </div>
</div>